import $ from 'jquery';
import Tips from './Tips';

/* ===============================================================
Gallery Social Class - Independent comments system
=============================================================== */
class GallerySocial {
    // Initialize
    constructor() {
        // Cache DOM elements
        this.socialItem = $('.irantheme-gallery-social-post-item');
        this.socialClose = $('.irantheme-gallery-social-fixed-close');
        this.socialCommentsOpen = $(
            '.irantheme-gallery-social-fixed-comments-open',
        );
        this.socialCommentsClose = $(
            '.irantheme-gallery-social-fixed-comments-close',
        );
        this.commentButtons = $(
            '.irantheme-gallery-social-fixed-comments-comment-button',
        );

        this.holder = $('.irantheme-gallery-social-fixed-holder');

        // State management
        this.swiperInstance = null;
        this.currentVideo = null;
        this.tip = new Tips();
        this.ajax_url = iranthemeWpData.adminAjax;
        this.isNavigating = false;

        // Initialize
        this.events();
    }

    // Events
    events() {
        // Open social fixed
        this.socialItem.on('click', (e) => {
            e.preventDefault();

            let item = $(e.currentTarget);
            let parentObject = item.closest('.irantheme-object');
            let code = parentObject.data('object');

            let targetElement = $(
                `.irantheme-gallery-social-fixed[data-code="${code}"]`,
            );
            targetElement.fadeIn(() => {
                this.initializeSwiper(targetElement);
                this.loadComments(targetElement);
            });
        });

        // Close social fixed
        this.socialClose.on('click', (e) => {
            e.preventDefault();
            this.close(e.currentTarget);
        });

        // Close with area
        $(document).on(
            'click',
            '.irantheme-gallery-social-fixed-holder',
            (e) => {
                if (
                    $(e.target).hasClass(
                        'irantheme-gallery-social-fixed-holder',
                    )
                ) {
                    this.close(e.target);
                }
            },
        );

        // Open comments
        this.socialCommentsOpen.on('click', (e) => {
            e.preventDefault();
            let item = $(e.currentTarget);
            let fixedElement = item.closest('.irantheme-gallery-social-fixed');
            this.pauseAllVideos(fixedElement);
            fixedElement
                .find('.irantheme-gallery-social-fixed-comments')
                .fadeIn();
        });

        // Close comments
        this.socialCommentsClose.on('click', (e) => {
            e.preventDefault();
            let item = $(e.currentTarget);
            let commentsElement = item.closest(
                '.irantheme-gallery-social-fixed-comments',
            );
            let fixedElement = commentsElement.closest(
                '.irantheme-gallery-social-fixed',
            );
            commentsElement.fadeOut();
            this.resumeCurrentVideo(fixedElement);
        });

        // Submit comment - using event delegation for dynamically added buttons
        $(document).on(
            'click',
            '.irantheme-gallery-social-fixed-comments-comment-button',
            (e) => {
                e.preventDefault();
                let button = $(e.currentTarget);

                // Prevent double submission
                if (button.prop('disabled')) {
                    return;
                }

                let objectId = button.data('object');
                let commentsContainer = button.closest(
                    '.irantheme-gallery-social-fixed-comments',
                );
                let textarea = commentsContainer.find(
                    '.irantheme-gallery-social-fixed-comments-comment-textarea',
                );
                let commentText = textarea.val().trim();

                if (!commentText) {
                    this.tip.createTip('error', 'لطفا متن دیدگاه را وارد کنید');
                    return;
                }

                if (!iranthemeWpData.isUserLoggedIn) {
                    this.tip.createTip(
                        'error',
                        'برای ثبت دیدگاه باید وارد حساب کاربری خود شوید',
                    );
                    return;
                }

                this.submitComment(
                    objectId,
                    commentText,
                    commentsContainer,
                    button,
                );
            },
        );

        // Navigate between stories (prev/next buttons)
        $(document).on('click', '.irantheme-gallery-social-fixed-nav', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let button = $(e.currentTarget);

            if (button.prop('disabled') || this.isNavigating) {
                return;
            }

            let currentFixed = button.closest(
                '.irantheme-gallery-social-fixed',
            );
            let direction = button.data('direction');

            this.navigateStory(currentFixed, direction);
        });

        // Keyboard navigation (Arrow keys)
        $(document).on('keydown', (e) => {
            let visibleFixed = $('.irantheme-gallery-social-fixed:visible');

            if (!visibleFixed.length || this.isNavigating) {
                return;
            }

            // Don't navigate when typing in input/textarea
            if ($(e.target).is('input, textarea, [contenteditable="true"]')) {
                return;
            }

            if (e.key === 'ArrowRight') {
                let prevBtn = visibleFixed.find(
                    '.irantheme-gallery-social-fixed-nav-prev:not(:disabled)',
                );
                if (prevBtn.length) {
                    e.preventDefault();
                    prevBtn.trigger('click');
                }
            } else if (e.key === 'ArrowLeft') {
                let nextBtn = visibleFixed.find(
                    '.irantheme-gallery-social-fixed-nav-next:not(:disabled)',
                );
                if (nextBtn.length) {
                    e.preventDefault();
                    nextBtn.trigger('click');
                }
            } else if (e.key === 'Escape') {
                e.preventDefault();
                visibleFixed.fadeOut();
                let fixedElement = visibleFixed;
                this.stopAllVideos(fixedElement);
                if (this.swiperInstance) {
                    this.swiperInstance.destroy();
                    this.swiperInstance = null;
                }
            }
        });
    }

    // Navigate to prev/next story
    navigateStory(currentFixed, direction) {
        if (!currentFixed.length) {
            return;
        }

        let currentIndex = parseInt(currentFixed.data('index'));
        if (isNaN(currentIndex)) {
            return;
        }

        let targetIndex =
            direction === 'next' ? currentIndex + 1 : currentIndex - 1;

        // Scope navigation to the parent section only
        // Each section has its own set of stories with data-index from 0..N
        let sectionScope = currentFixed.closest(
            '.irantheme-gallery-social-section',
        );

        if (!sectionScope.length) {
            // Fallback: if no section wrapper found, fall back to global scope
            sectionScope = $(document);
        }

        let targetFixed = sectionScope.find(
            `.irantheme-gallery-social-fixed[data-index="${targetIndex}"]`,
        );

        if (!targetFixed.length) {
            return;
        }

        this.isNavigating = true;

        // Stop videos and destroy swiper of current
        this.stopAllVideos(currentFixed);
        if (this.swiperInstance) {
            this.swiperInstance.destroy();
            this.swiperInstance = null;
        }
        this.currentVideo = null;

        // Hide current story FIRST, then show target
        currentFixed.hide();

        // Safety: hide any other visible story WITHIN THE SAME SECTION only
        sectionScope
            .find('.irantheme-gallery-social-fixed:visible')
            .not(targetFixed)
            .hide();

        // Show target
        targetFixed.show(0, () => {
            // Initialize swiper for target
            this.initializeSwiper(targetFixed);
            this.loadComments(targetFixed);

            // Focus target for keyboard navigation
            targetFixed.attr('tabindex', '-1').trigger('focus');

            this.isNavigating = false;
        });
    }

    // Close fixed
    close(element) {
        let item = $(element);
        let fixedElement = item.closest('.irantheme-gallery-social-fixed');
        this.stopAllVideos(fixedElement);
        if (this.swiperInstance) {
            this.swiperInstance.destroy();
            this.swiperInstance = null;
        }
        this.currentVideo = null;
        fixedElement.fadeOut();
    }

    // Submit comment via AJAX
    submitComment(objectId, commentText, container, button) {
        let textarea = container.find(
            '.irantheme-gallery-social-fixed-comments-comment-textarea',
        );

        // Disable button and show loading state
        button.prop('disabled', true);
        button.html('در حال ارسال...');

        $.ajax({
            url: this.ajax_url,
            method: 'POST',
            data: {
                action: 'submit_gallery_comment',
                object_id: objectId,
                comment: commentText,
                nonce: iranthemeWpData.galleryNonce || iranthemeWpData.nonce,
            },
            success: (response) => {
                if (response.success) {
                    // Clear textarea
                    textarea.val('');
                    // Add new comment to list
                    this.addCommentToList(container, response.data);
                    // Update comment count in header
                    this.updateCommentCount(container, response.data.count);
                    this.tip.createTip(
                        'success',
                        'دیدگاه شما با موفقیت ثبت شد',
                    );
                } else {
                    this.tip.createTip(
                        'error',
                        response.data.message || 'خطا در ثبت دیدگاه',
                    );
                }
            },
            error: (xhr, status, error) => {
                console.error('Comment submission error:', error);
                let errorMessage = 'خطا در ارتباط با سرور';
                if (
                    xhr.responseJSON &&
                    xhr.responseJSON.data &&
                    xhr.responseJSON.data.message
                ) {
                    errorMessage = xhr.responseJSON.data.message;
                }
                this.tip.createTip('error', errorMessage);
            },
            complete: () => {
                // Re-enable button
                button.prop('disabled', false);
                button.html('ثبت <i class="iconsax" icon-name="edit-1"></i>');
            },
        });
    }

    // Add new comment to the list
    addCommentToList(container, commentData) {
        let list = container.find(
            '.irantheme-gallery-social-fixed-comments-list',
        );
        let emptyMsg = container.find(
            '.irantheme-gallery-social-fixed-comments-empty',
        );

        // Remove empty message if exists
        if (emptyMsg.length) {
            emptyMsg.remove();
        }

        // Escape HTML to prevent XSS
        const escapeHtml = (text) => {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        };

        let commentHtml = `
            <div class="irantheme-gallery-social-fixed-comments-review" data-comment-id="${escapeHtml(
                commentData.id,
            )}">
                <div class="irantheme-gallery-social-fixed-comments-review-avatar">
                    <img src="${escapeHtml(
                        commentData.avatar,
                    )}" alt="${escapeHtml(
                        commentData.user_name,
                    )} avatar" width="48" height="48">
                </div>
                <div class="irantheme-gallery-social-fixed-comments-review-content">
                    <strong class="irantheme-gallery-social-fixed-comments-review-content-name">${escapeHtml(
                        commentData.user_name,
                    )}</strong>
                    <p class="irantheme-gallery-social-fixed-comments-review-content-comment">${escapeHtml(
                        commentData.comment,
                    )}</p>
                </div>
            </div>
        `;

        // Prepend new comment to list
        list.prepend(commentHtml);
    }

    // Update comment count in header
    updateCommentCount(container, newCount) {
        let header = container
            .closest('.irantheme-gallery-social-fixed')
            .find('.irantheme-gallery-social-fixed-holder-media-header');
        let commentLink = header.find(
            '.irantheme-gallery-social-fixed-comments-open',
        );
        commentLink.find('cite').text(newCount);
    }

    // Load comments when opening the gallery
    loadComments(container) {
        let commentsContainer = container.find(
            '.irantheme-gallery-social-fixed-comments',
        );
        let objectId = commentsContainer.data('object');

        if (!objectId) {
            return;
        }

        // Refresh comments list via AJAX
        $.ajax({
            url: this.ajax_url,
            method: 'GET',
            data: {
                action: 'get_gallery_comments',
                object_id: objectId,
            },
            success: (response) => {
                if (response.success) {
                    let list = commentsContainer.find(
                        '.irantheme-gallery-social-fixed-comments-list',
                    );
                    list.html(response.data.html);

                    // Update empty state
                    let emptyMsg = commentsContainer.find(
                        '.irantheme-gallery-social-fixed-comments-empty',
                    );
                    if (response.data.count === 0) {
                        if (!emptyMsg.length) {
                            let emptyHtml = `
                                <div class="irantheme-gallery-social-fixed-comments-empty">
                                    <i class="iconsax" icon-name="messages-1"></i>
                                    <p>دیدگاهی موجود نمی باشد.</p>
                                </div>
                            `;
                            commentsContainer.append(emptyHtml);
                        }
                    } else if (emptyMsg.length) {
                        emptyMsg.remove();
                    }
                }
            },
            error: (xhr, status, error) => {
                console.error('Load comments error:', error);
            },
        });
    }

    // Initialize Swiper with video handling
    initializeSwiper(container) {
        const swiperContainer = container.find(
            '.irantheme-gallery-social-fixed-swiper',
        );

        if (!swiperContainer.length) {
            return;
        }

        if (this.swiperInstance) {
            this.swiperInstance.destroy();
            this.swiperInstance = null;
        }

        this.swiperInstance = new Swiper(swiperContainer[0], {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
                el: swiperContainer.find('.swiper-pagination')[0],
                clickable: true,
            },
            navigation: {
                nextEl: swiperContainer.find('.swiper-button-next')[0],
                prevEl: swiperContainer.find('.swiper-button-prev')[0],
            },
            lazy: {
                enabled: true,
                loadOnTransitionStart: true,
                loadPrevNext: true,
            },
            on: {
                init: (swiper) => {
                    this.handleSlideChange(swiper);
                    this.loadActiveVideo(swiper);
                },
                slideChange: (swiper) => {
                    this.handleSlideChange(swiper);
                    this.loadActiveVideo(swiper);
                },
                slideChangeTransitionEnd: (swiper) => {
                    this.playCurrentVideo(swiper);
                },
            },
        });

        // Setup video click handlers
        this.setupVideoHandlers(container);
    }

    // Handle slide change - pause all videos
    handleSlideChange(swiper) {
        const container = $(swiper.el).closest(
            '.irantheme-gallery-social-fixed',
        );
        if (container.length) {
            this.pauseAllVideos(container);
        }
    }

    // Play current video in active slide
    playCurrentVideo(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        const video = $(activeSlide).find('video')[0];

        if (video) {
            // Pause any other playing video
            if (this.currentVideo && this.currentVideo !== video) {
                this.currentVideo.pause();
                this.removePlayingStyle(
                    $(this.currentVideo).closest('.video-container'),
                );
                this.updatePlayPauseButtons(
                    $(this.currentVideo).closest('.video-container'),
                    false,
                );
            }

            video.currentTime = 0;

            // Play video with user interaction handling
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        this.currentVideo = video;
                        this.addPlayingStyle(
                            $(video).closest('.video-container'),
                        );
                        this.updatePlayPauseButtons(
                            $(video).closest('.video-container'),
                            true,
                        );
                    })
                    .catch((error) => {
                        console.log('Video autoplay failed:', error);
                        this.updatePlayPauseButtons(
                            $(video).closest('.video-container'),
                            false,
                        );
                    });
            }

            // Handle video end
            video.onended = () => {
                const videoContainer = $(video).closest('.video-container');
                this.removePlayingStyle(videoContainer);
                this.updatePlayPauseButtons(videoContainer, false);
                if (this.currentVideo === video) {
                    this.currentVideo = null;
                }
            };
        } else {
            if (this.currentVideo) {
                this.currentVideo.pause();
                this.removePlayingStyle(
                    $(this.currentVideo).closest('.video-container'),
                );
                this.updatePlayPauseButtons(
                    $(this.currentVideo).closest('.video-container'),
                    false,
                );
                this.currentVideo = null;
            }
        }
    }

    // Update play/pause buttons visibility
    updatePlayPauseButtons(container, isPlaying) {
        if (!container.length) return;

        const playButton = container.find('.video-play-button');
        const pausedOverlay = container.find('.video-paused-overlay');

        if (isPlaying) {
            playButton.css('display', 'none');
            pausedOverlay.css('display', 'none');
        } else {
            playButton.css('display', 'flex');
            pausedOverlay.css('display', 'none');
        }
    }

    // Setup video click handlers for play/pause
    setupVideoHandlers(container) {
        container
            .find('.video-container')
            .off('click')
            .on('click', (e) => {
                e.stopPropagation();
                const videoContainer = $(e.currentTarget);
                const video = videoContainer.find('video')[0];

                if (!video) return;

                // Loading video prev of play
                if (!video.src && video.dataset.src) {
                    video.src = video.dataset.src;
                    video.load();
                }

                if (video.paused) {
                    // Play video
                    if (this.currentVideo && this.currentVideo !== video) {
                        this.currentVideo.pause();
                        const oldContainer = $(this.currentVideo).closest(
                            '.video-container',
                        );
                        this.removePlayingStyle(oldContainer);
                        this.updatePlayPauseButtons(oldContainer, false);
                    }

                    const playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise
                            .then(() => {
                                this.currentVideo = video;
                                this.addPlayingStyle(videoContainer);
                                this.updatePlayPauseButtons(
                                    videoContainer,
                                    true,
                                );
                            })
                            .catch((error) => {
                                console.log('Video play failed:', error);
                                this.updatePlayPauseButtons(
                                    videoContainer,
                                    false,
                                );
                            });
                    }

                    // Handle video end
                    video.onended = () => {
                        this.removePlayingStyle(videoContainer);
                        this.updatePlayPauseButtons(videoContainer, false);
                        if (this.currentVideo === video) {
                            this.currentVideo = null;
                        }
                    };
                } else {
                    // Pause video
                    video.pause();
                    this.removePlayingStyle(videoContainer);
                    this.updatePlayPauseButtons(videoContainer, false);
                    if (this.currentVideo === video) {
                        this.currentVideo = null;
                    }
                }
            });

        // Hover effects for video containers
        container.find('.video-container').hover(
            function () {
                const video = $(this).find('video')[0];
                if (video && !video.paused) {
                    $(this).find('.video-paused-overlay').fadeIn(200);
                }
            },
            function () {
                const video = $(this).find('video')[0];
                if (video && !video.paused) {
                    $(this).find('.video-paused-overlay').fadeOut(200);
                }
            },
        );
    }

    // Pause all videos in container
    pauseAllVideos(container) {
        if (!container.length) return;

        const videos = container.find('video');
        videos.each((index, video) => {
            if (!video.paused) {
                video.pause();
                const videoContainer = $(video).closest('.video-container');
                this.removePlayingStyle(videoContainer);
                this.updatePlayPauseButtons(videoContainer, false);
            }
        });
        this.currentVideo = null;
    }

    // Stop all videos (reset to beginning)
    stopAllVideos(container) {
        if (!container.length) return;

        const videos = container.find('video');
        videos.each((index, video) => {
            video.pause();
            video.currentTime = 0;
            const videoContainer = $(video).closest('.video-container');
            this.removePlayingStyle(videoContainer);
            this.updatePlayPauseButtons(videoContainer, false);
        });
        this.currentVideo = null;
    }

    // Resume current video after closing comments
    resumeCurrentVideo(container) {
        if (!container.length || !this.currentVideo) return;

        if (this.currentVideo && this.currentVideo.paused) {
            const videoContainer = $(this.currentVideo).closest(
                '.video-container',
            );
            const playPromise = this.currentVideo.play();
            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        this.addPlayingStyle(videoContainer);
                        this.updatePlayPauseButtons(videoContainer, true);
                    })
                    .catch((error) => {
                        console.log('Video resume failed:', error);
                        this.updatePlayPauseButtons(videoContainer, false);
                    });
            }
        }
    }

    // Add playing style to video container
    addPlayingStyle(container) {
        if (container.length) {
            container.addClass('video-playing');
        }
    }

    // Remove playing style from video container
    removePlayingStyle(container) {
        if (container.length) {
            container.removeClass('video-playing');
        }
    }

    // Load video of active slide, unload others
    loadActiveVideo(swiper) {
        if (!swiper || !swiper.slides) return;

        const activeSlide = swiper.slides[swiper.activeIndex];
        if (!activeSlide) return;

        const container = $(swiper.el).closest(
            '.irantheme-gallery-social-fixed',
        );

        // Load active slider
        const activeVideo = activeSlide.querySelector('video[data-src]');
        if (activeVideo && !activeVideo.src) {
            activeVideo.src = activeVideo.dataset.src;
            activeVideo.load();
        }

        // Unload other of sliders
        if (container.length) {
            container.find('video[data-src]').each((i, video) => {
                if (video !== activeVideo && video.src) {
                    video.pause();
                    video.removeAttribute('src');
                    video.load();
                }
            });
        }
    }
}

export default GallerySocial;
